import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Background color of the *selected* pill in the Feed's filter toolbar. Own
// key (not feed-level BackgroundColor) so it doesn't compete in styleGuides.
export default class FilterToolbarBackgroundColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter Selected Pill Background",
    component: inspectorTools.COLOR_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      width: "fill",
      displayAsSelectInput: true,
      colorContext: "Backgrounds",
    },
  };

  static defaultValue = {
    value: "transparent.100",
    source: "palette.background",
  };

  // eslint-disable-next-line no-unused-vars
  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit", optionValues = {}) {
    if (configValue === "none") {
      return "transparent";
    }
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];
    if (configValue.source && configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue?.value || "transparent";
  }
}
